import React, { useState } from "react";
import "./FloatingLabelInput.scss";

const FloatingLabelInput = ({
  type = "text",
  name,
  placeholder,
  defaultValue = "",
  className = "",
  formatPhone = false,
  required = true,
  onKeyChangeCallback = () => {},
  valueChangeCallback = () => {},
}) => {
  const [value, setValue] = useState(defaultValue);
  const [isFocused, setIsFocused] = useState(false);
  const [hasBlurred, setHasBlurred] = useState(false);

  const formatPhoneNumber = (input) => {
    const numbers = input.replace(/\D/g, "");
    if (numbers.length <= 3) {
      return numbers;
    } else if (numbers.length <= 6) {
      return `${numbers.slice(0, 3)}-${numbers.slice(3)}`;
    } else {
      return `${numbers.slice(0, 3)}-${numbers.slice(3, 6)}-${numbers.slice(6, 10)}`;
    }
  };

  const handleChange = (e) => {
    let newValue = e.target.value;
    
    if (formatPhone) {
      const numbers = newValue.replace(/\D/g, "");
      if (numbers.length <= 10) {
        newValue = formatPhoneNumber(newValue);
        setValue(newValue);
        onKeyChangeCallback(name, numbers); // Send unformatted numbers
      }
    } else {
      setValue(newValue);
      onKeyChangeCallback(name, newValue);
    }
  };

  const handleFocus = () => {
    setIsFocused(true);
  };

  const handleBlur = () => {
    setIsFocused(false);
    setHasBlurred(true);
    valueChangeCallback(name, value);
  };

  const shouldShowError = required && hasBlurred && !value.trim();
  const finalClassName = `${className} ${shouldShowError ? 'red-border-input' : ''}`;

  return (
    <div className={`floating-label-container ${finalClassName}`}>
      <input
        type={type}
        name={name}
        value={value}
        onChange={handleChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
        className="floating-input"
        required={required}
      />
      <label
        className={`floating-label ${
          isFocused || value ? "floating-label-active" : ""
        }`}
      >
        {placeholder}
      </label>
    </div>
  );
};

export default FloatingLabelInput;
